import { User } from 'models/User';
import UserService from 'services/UserService';
import useSWR, { mutate } from 'swr';
import swrConfig from 'utils/swrConfig';

export const USER_DATA_SWR_KEY = 'userData';

/**
 * Fetches the logged-in user's profile. Usable outside React (thunks, services) — prefer
 * `preloadUserData` so the result also lands in the cache `useUserData` reads.
 */
export async function fetchUserData(): Promise<User | undefined> {
    const response = await UserService.getData();
    return response?.user;
}

/**
 * Fetches the user data and seeds the SWR cache with it, so components mounting later read
 * the bootstrapped value instead of firing a second request.
 */
export async function preloadUserData(): Promise<User | undefined> {
    const userData = await fetchUserData();
    await mutate(USER_DATA_SWR_KEY, userData, { revalidate: false });
    return userData;
}

export const useUserData = () => {
    const { data, error, isLoading, mutate: refetch } = useSWR<User>(USER_DATA_SWR_KEY, fetchUserData, swrConfig);

    return { data, error, isLoading, refetch };
};
